<span [matTooltip]="title" class="abbr">
    <ng-content></ng-content>
</span>
